<template>
  <div v-if="heroSliderItems">
    <flickity ref="flickity" :options="flickityOptions" class="hero container bg-wht hero-carousel">
      <div class="carousel-cell" v-for="(slider, idx) in heroSliderItems" :key="idx">
        <div class="hero-image full-layout" :style="{ backgroundImage: 'url(' + slider.fields.backgroundImage.fields.file.url + ')' }">
          <div class="content-wrapper">
            <div class="content trimmed-width-1">
              <div class="text-xs-center text-sm-left">
                <h1 class="mb-4" v-html="$sanitize(slider.fields.title)"></h1>
                <p class="subtitle font-weight-extralight mb-4">{{ slider.fields.subline }}</p>
                <div class="cta-wrapper">
                  <a :href="slider.fields.ctaLink" class="btn btn-primary wdth-80" :title="slider.fields.ctaLink">
                    {{ slider.fields.ctaTitle }}
                  </a>
                  <a v-show="slider.fields.ctaTitle2" :href="slider.fields.ctaLink2"
                    class="btn btn-primary-inverted wdth-80 mt-3 mt-sm-0 ml-sm-3" :title="slider.fields.ctaLink2">
                    {{ slider.fields.ctaTitle2 }}
                  </a>
                </div>
              </div>
            </div><!-- .content -->
          </div><!-- .content-wrapper -->
        </div><!-- .hero-image -->
      </div><!-- .carousel-cell -->
    </flickity>
  </div>
</template>

<script>
  import Flickity from 'vue-flickity';

  export default {
    name: 'carouselHeroApp',
    components: { Flickity },
    props:["heroSliderItems"],
    data() {
      return {
        flickityOptions: {
          "wrapAround": false,
          "cellAlign": "left",
          "contain": true,
          "prevNextButtons": false,
          "pageDots": true,
          "resize": false,
          "autoPlay": 8000,
          "adaptiveHeight": false,
          "pauseAutoPlayOnHover": false
        }
      }
    }
  }
</script>
